<div class="calendar-container" [style.display]="'flex'" [style.justify-content]="props['align'] ?? 'center'">
  <mat-card class="calendar-card">
    <!-- <mat-calendar [headerComponent]="customHeader" -->
    <mat-calendar [selected]="formControl.value || now"
                  [startAt]="now"
                  (selectedChange)="formControl.setValue($event)" />
  </mat-card>
</div>